import { ReactNode, useState } from 'react';

export interface WorkspaceTab {
  key: string;
  label: string;
  content: ReactNode;
}

interface WorkspaceTabsProps {
  tabs: WorkspaceTab[];
  defaultTab?: string;
}

/**
 * THE single tab-switching implementation for every workspace page in
 * VConnect - detail pages that used to be a stack of cards, and pages
 * that used to open a RecordDetailModal from a list. Lightweight
 * client-side tab state (like the original StaffDetailPage), not real
 * nested routes (like ProjectWorkspaceLayout) - deliberately chosen for
 * lower risk applying this everywhere at once, over 24 pages, rather
 * than adding real routes to every one of them.
 *
 * Tracking is always one of these tabs, never a stacked block under the
 * page content - that was the whole point of this component existing.
 */
export function WorkspaceTabs({ tabs, defaultTab }: WorkspaceTabsProps) {
  const [activeKey, setActiveKey] = useState(defaultTab ?? tabs[0]?.key);
  const active = tabs.find((t) => t.key === activeKey) ?? tabs[0];

  return (
    <div className="workspace-tabs-wrapper">
      <nav className="workspace-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={'workspace-tab' + (tab.key === activeKey ? ' workspace-tab-active' : '')}
            onClick={() => setActiveKey(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className="workspace-tab-content">{active?.content}</div>
    </div>
  );
}
